import React from 'react';

const PillarCard = ({ icon, title, children }) => (
  <div className="bg-[#1E293B] border border-gray-700 p-8 rounded-2xl shadow-xl hover:border-[#C5A059] transition-all duration-300 group flex flex-col items-center text-center h-full relative overflow-hidden">
    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#C5A059] to-transparent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
    
    <div className="w-16 h-16 bg-[#0F172A] rounded-full flex items-center justify-center text-[#C5A059] text-2xl mb-6 border border-gray-600 group-hover:scale-110 transition-transform shadow-lg">
      <i className={`fas ${icon}`}></i>
    </div>
    
    <h3 className="text-xl font-serif font-bold text-white mb-4 group-hover:text-[#C5A059] transition-colors">
      {title}
    </h3>
    
    <div className="text-sm text-gray-300 leading-relaxed font-light w-full">
      {children}
    </div>
  </div>
);

const MissionValues = () => {
  return (
    <section className="py-12 w-full">
      <div className="max-w-7xl mx-auto px-4">
        <div className="mb-10 text-center">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-white inline-block border-b-2 border-[#C5A059] pb-2">
            Pilares Institucionais
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <PillarCard icon="fa-bullseye" title="Nossa Missão">
            <p className="text-justify">
              Prover defesa intransigente e estratégica. Transformar a complexidade jurídica em soluções claras, aliando o rigor processual à sensibilidade humana necessária para lidar com direitos fundamentais, a liberdade e a vida.
            </p>
          </PillarCard>
          
          <PillarCard icon="fa-globe-americas" title="Nossa Visão">
            <p className="text-justify">
              A <strong>Ubiquidade do Direito</strong>: Romper as barreiras físicas da advocacia tradicional. Garantir que a justiça técnica de excelência esteja acessível digitalmente em qualquer lugar do Brasil, com a mesma proximidade e segurança do atendimento presencial.
            </p>
          </PillarCard>
          
          <PillarCard icon="fa-chess-knight" title="Nossos Valores">
            <ul className="space-y-3 text-left w-full pl-2">
              <li className="flex items-start gap-2">
                <i className="fas fa-check text-[#C5A059] mt-1 text-xs"></i>
                <span><strong>Excelência Técnica:</strong> Rigor processual inegociável.</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="fas fa-check text-[#C5A059] mt-1 text-xs"></i>
                <span><strong>Ética Animalista:</strong> Compromisso com toda forma de vida.</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="fas fa-check text-[#C5A059] mt-1 text-xs"></i>
                <span><strong>Estratégia:</strong> Visão de enxadrista (Antecipação).</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="fas fa-check text-[#C5A059] mt-1 text-xs"></i>
                <span><strong>Transparência:</strong> Clareza radical sobre riscos.</span>
              </li>
            </ul>
          </PillarCard>
        </div>
      </div>
    </section>
  );
};

export default MissionValues;